import {_} from 'lodash';
import * as ko from "knockout";
import {ICompanyLogin, IOrganization} from "../../../../index";
import {global, lm} from "../../../../appContext";
import {IComboboxV2Options} from "../../../combobox/v2";
import {nsTooltip} from "../../../../util/nsTooltip";
import {storeObservable} from "../../../../util/sessionstore";
import target_org_comboboxHtml from './target-org-combobox.html?raw';

export const template = target_org_comboboxHtml;

export interface ITargetOrgComboboxParams {
    selected: KnockoutObservable<IOrganization | null>;
    organizations?: KnockoutObservableArray<IOrganization>;
    inputId?: string;
    ariaLabelledBy?: string;
}

export class viewModel {
    readonly v2Options: IComboboxV2Options<IOrganization>;

    constructor(public readonly params: ITargetOrgComboboxParams) {
        const organizations = params.organizations ?? global.login.organizations;
        const inputAttrs: NonNullable<IComboboxV2Options<IOrganization>['inputAttrs']> = {
            placeholder: lm.t("choose organization"),
            title: lm.t("choose organization"),
            ariaLabel: lm.t("choose organization"),
        };
        if (params.inputId) {
            inputAttrs.id = params.inputId;
        }
        // aria-labelledby is not in IComboboxV2InputAttrs; keep same behaviour as before.

        this.v2Options = {
            prepareData: {
                map: (arr) => {
                    const companylogin_selected = storeObservable("selected.company.login")() as ICompanyLogin;
                    if (companylogin_selected?.vanityindex) {
                        const mapped = _.cloneDeep(arr);
                        const item = mapped.find(
                            (o: IOrganization) => o.organizationid == companylogin_selected.orgnr,
                        );
                        if (item) {
                            item.organizationame = companylogin_selected.name;
                        }
                        return mapped;
                    }
                    return arr;
                },
            },
            inputAttrs,
            wrapperClass: "combobox-organization ruleset-copy-wizard__target-org-combobox",
            enable: true,
            option: {
                label: (o) => o?.organizationame ?? "",
                tooltip: (o) => o ? (lm.t(nsTooltip.getTitle_organization(o)) ?? "") : "",
            },
            initialMatch: (o) => !!o && o.organizationid == params.selected()?.organizationid,
            restoreLastValidOnBlur: true,
            selected: params.selected,
            data: organizations,
        };
    }
}
